import StripeVerificationPageContainer from './container';

export default StripeVerificationPageContainer;
